// import Menu from './components/Menu';
import TabsContainer from './pages/TabsContainer';
import React from 'react';
import {
  IonApp,
  IonRouterOutlet,
  IonSplitPane,
  IonLoading,
} from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import { Redirect, Route } from 'react-router-dom';

import { connect } from 'react-redux';
import * as actionCreator from './store/actions/userActions';
import * as ordActionCreator from './store/actions/orderActions';
import * as invActionCreator from './store/actions/inventoryActions';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* Theme variables */
import './theme/variables.css';
import Login from './pages/Login';

const App: React.FC = (props: any) => {
  if (!props.user) {
    return <Login />;
  }

  return (
    <IonApp>
      <IonReactRouter>
        <IonSplitPane contentId="main">
          <IonRouterOutlet id="main">
            <Route path="/dashboard" component={TabsContainer} exact />
            <Route path="/orders" component={TabsContainer} exact />
            <Route path="/inventory" component={TabsContainer} exact />
            <Route path="/profile" component={TabsContainer} exact />

            <Redirect from="/addOrder" to="/orders" exact />
            <Redirect from="/order/:id" to="/orders" exact />
            <Redirect from="/editOrder/:id" to="/orders" exact />

            <Redirect from="/addItem" to="/inventory" exact />
            <Redirect from="/item/:id" to="/inventory" exact />
            <Redirect from="/editItem/:id" to="/inventory" exact />

            <Redirect from="/editUser" to="/orders" exact />

            <Route path="/" component={TabsContainer} />
            <Route path="" component={TabsContainer} />
          </IonRouterOutlet>
        </IonSplitPane>
      </IonReactRouter>
    </IonApp>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.userReducer.user,
    userDBInfo: state.userReducer.userDbInfo,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    onSetUser: (payload: {}) => dispatch(actionCreator.setUser(payload)),
    onGetOrders: (payload: any) =>
      dispatch(ordActionCreator.getOrders(payload)),
    onGetItems: (payload: any) => dispatch(invActionCreator.getItems(payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
